import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { useToast } from '../../hooks/use-toast';
import { Download, Database, Users, FileText, Phone as PhoneIcon, CreditCard, Ticket, Tag, UserPlus } from 'lucide-react';
import { BACKEND_URL } from "../../lib/backendUrl";
const API = `${BACKEND_URL}/api`;

const collections = [
  { key: 'users', label: 'Users', icon: Users, desc: 'All registered users (passwords excluded)' },
  { key: 'subscriptions', label: 'Subscriptions', icon: CreditCard, desc: 'All subscription records' },
  { key: 'invoices', label: 'Invoices', icon: FileText, desc: 'All invoices and line items' },
  { key: 'contacts', label: 'Contacts (CRM)', icon: Users, desc: 'All CRM contacts' },
  { key: 'calls', label: 'Calls', icon: PhoneIcon, desc: 'Call history and transcripts' },
  { key: 'promo_codes', label: 'Promo Codes', icon: Tag, desc: 'All promo codes' },
  { key: 'affiliates', label: 'Affiliates', icon: UserPlus, desc: 'Affiliate partners' },
];

const AdminData = () => {
  const { token } = useAuth();
  const { toast } = useToast();

  const exportData = async (collection) => {
    try {
      const res = await fetch(`${API}/admin/export/${collection}`, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error('Export failed');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${collection}_export.csv`;
      a.click();
      window.URL.revokeObjectURL(url);
      toast({ title: `${collection} exported` });
    } catch {
      toast({ title: 'Export failed', description: 'No data or server error', variant: 'destructive' });
    }
  };

  return (
    <div data-testid="admin-data-page">
      <h1 className="text-2xl font-bold text-white mb-1">Data Management</h1>
      <p className="text-gray-500 text-sm mb-6">Export platform data as CSV files</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {collections.map(col => (
          <Card key={col.key} className="bg-[#132218] border-emerald-900/30" data-testid={`export-${col.key}`}>
            <CardContent className="p-4 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-emerald-600/10 flex items-center justify-center">
                  <col.icon className="w-5 h-5 text-emerald-400" />
                </div>
                <div>
                  <p className="text-white text-sm font-medium">{col.label}</p>
                  <p className="text-gray-500 text-xs">{col.desc}</p>
                </div>
              </div>
              <Button onClick={() => exportData(col.key)} size="sm" className="bg-emerald-600/20 text-emerald-400 hover:bg-emerald-600/30" data-testid={`export-btn-${col.key}`}>
                <Download className="w-4 h-4 mr-1" />Export
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AdminData;
